import React from "react";
import MedicationPriceElementV3 from "./medication-price-element-v3";
import {useSelector} from "react-redux";
import {RootState} from "../../../../../state/store/configureMedWidgetStore";
import {MedicationPrice} from "../../../../../state/types/MedicationWidget";
import {generateSaveWithPrimePriceString} from "../../../utils/med-widget-utils";

const generateTotalRetailPriceString = (currentMedicationPrice: MedicationPrice) => {
    return `${currentMedicationPrice.totalRetailPrice.currencySymbol}${currentMedicationPrice.totalRetailPrice?.amount.toFixed(2)}`;
}

const MedicationPriceCardV3 = () => {
    const currentMedicationPrice = useSelector((state: RootState) => state.medicationWidgetState.currentMedicationPrice);

    return (
        <>
            <pui-heading textSize="large" spacingbottom="medium" input="Estimate price for a specific medication from Amazon Pharmacy"></pui-heading>
            <pui-section class="medication-price-card-v3" flowDirection="horizontal" fullWidth>
                <pui-section class="left-section" flowDirection="vertical" secondaryAxisArrangement="start">
                    {!!currentMedicationPrice.totalPrimePrice &&
                        <>
                            <MedicationPriceElementV3 price={currentMedicationPrice.totalPrimePrice}/>
                            <div>
                                <pui-text input="Retail price:" textSize="small" fontWeight="normal" textalign="center" inline></pui-text>
                                <pui-text input={generateTotalRetailPriceString(currentMedicationPrice)} spacingleft="mini" inline
                                          textSize="small" fontWeight="normal" textColor="black" textDecorationLine="line-through">
                                </pui-text>
                                <pui-text input={generateSaveWithPrimePriceString(currentMedicationPrice)}
                                          textSize="small" fontWeight="normal" textColor="black">
                                </pui-text>
                            </div>
                        </>
                    }
                </pui-section>
                <div className="divider"/>
                <pui-section class="right-section" flowDirection="vertical">
                    {!!currentMedicationPrice.perPillPrimePrice &&
                        <>
                            <MedicationPriceElementV3 price={currentMedicationPrice.perPillPrimePrice}/>
                            <pui-text input="per tablet" textSize="small" fontWeight="normal" textalign="center" inline></pui-text>

                        </>
                    }
                </pui-section>
            </pui-section>
        </>
    )
}

export default MedicationPriceCardV3;
